import { getCookie } from "cookies-next";

export const formatMoney = (value, currency) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(value);
  
  export const formatTime = timestamp => {
      const date = new Date(timestamp);
    
      const options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        // hour: '2-digit',
        // minute: '2-digit',
        // second: '2-digit',
        // timeZoneName: 'short',
      };
    
      const formattedDate = date.toLocaleString('en-US', options);
    
      return formattedDate;
    };
  
    export const capitalizeFirstLetter = (string) => {
      return string.charAt(0).toUpperCase() + string.slice(1);
  }



  export const authanticatedUser = (getCookie('loggedInUser')) ?  JSON.parse(getCookie('loggedInUser')) : null;
  export const ablToken = (getCookie('ablToken')) ?  getCookie('ablToken') : null;

  export const authToken = token => {
    // loggedIn user authorized token header
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    return headers;
  };

  export const axiosHeader = token => {
    // loggedIn user authorized token header
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    return {headers: headers};
  };


  export const basicAuth = () => {
    // loggedIn user authorized token header
    
    const headers = {
      // 'Content-Type': 'application/json',
      // 'Origin':'http://localhost:3000',
      // 'Access-Control-Allow-Credentials': 'true',
      auth: {
        username: process.env.REACT_APP_ACCESSBANK_USERNAME,
        password: process.env.REACT_APP_ACCESSBANK_PASSWORD,
      },
    };

    console.log(headers)
    return headers;
  };


  export const radomCharactors = (length) => {
    var charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
}


export const branches = [
    'buchanan',
    'sinkor',
    'head-Office',
    'duala',
    'ELWA',
    'garnesville',
    'johnson-street',
    'red-light',
    'kakata',
    'gbanga',
    'ganta'
];

